<script setup>
import { stringToColor, getInitials } from '@/lib/utils'
import { useWebSiteStore } from '@/stores/web-site.store'

defineProps({
  ids: {
    type: Array,
    required: true
  },
  maxShown: {
    type: Number,
    default: 2
  }
})

const webSiteStore = useWebSiteStore()

const getMechanicName = (id) => {
  const u = webSiteStore.userDetails.find(i => i.id === id)
  return u ? `${u.name} ${u.name_ext}` : ''
}
</script>

<template>
  <div class="mechanics-avatar-list">
    <q-avatar
      v-for="id in ids.slice(0, maxShown)"
      :key="id"
      size="28px"
      font-size="12px"
      text-color="white"
      :style="{ backgroundColor: stringToColor(getInitials(getMechanicName(id))) }"
      :title="getMechanicName(id)"
    >
      {{ getInitials(getMechanicName(id)) }}
    </q-avatar>
    <q-avatar
      v-if="ids.length > maxShown"
      size="1.25rem"
      font-size=".8rem"
      color="grey-6"
      text-color="white"
      title="Other mechanics"
    >
      +{{ ids.length - maxShown }}
    </q-avatar>
  </div>
</template>
<style scoped>
.mechanics-avatar-list {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: .25rem;
  overflow: hidden;
}
</style>
